import React, { useState } from "react";

import styles from "./styles/Partners.module.css";
import { Select } from "antd";
import { downloadPartnersCSV } from "../../../Utils/adminPartnerUtils";
function TableFilter({
  globalSearch,
  component,
  setUserStatus,
  setRewardStatus,
  setPromotionTypeFilter,
  createdByOptions,
  loadingAdminNames,
  setCreatedByFilter,
}) {
  if (component === "PartnerDataPopup") {
    const rewardStatusOptions = [
      {
        label: "Pending",
        value: "pending",
      },

      {
        label: "Unclaimed",
        value: "unclaimed",
      },
      {
        label: "Paid",
        value: "Paid",
      },
      {
        label: "Done",
        value: "done",
      },
      {
        label: "None",
        value: "none",
      },
    ];
    const userStatusOptions = [
      {
        label: "Trial Account",
        value: "trial",
      },
      {
        label: "Customer In Cancelation Period",
        value: "cancelation",
      },
      {
        label: "Subscribed",
        value: "subscription",
      },
      {
        label: "Invited",
        value: "invitation",
      },
    ];
    return (
      <div
        className={styles.filter_div}
        style={{
          gap: "25px",
        }}
      >
        <div
          className={styles.left}
          style={{
            width: "130%",
          }}
        >
          <div
            className={styles.input}
            style={{
              width: "100%",
            }}
          >
            <div onClick={() => null} className={styles.search_logo}></div>
            <input
              placeholder="Search"
              className={styles.input_input}
              onChange={(e) => globalSearch(e.target.value)}
            ></input>
          </div>
        </div>
        <div className={styles.rightPart}>
          <Select
            allowClear={true}
            onChange={(e) => {
              setUserStatus(e);
            }}
            placeholder="Status"
            style={{
              width: "150px",
              height: "46px",
            }}
            options={userStatusOptions}
          />
          <Select
            allowClear={true}
            onChange={(e) => {
              setRewardStatus(e);
            }}
            // defaultValue="Pending"
            placeholder="Reward Status"
            style={{
              width: "150px",
              height: "46px",
            }}
            options={rewardStatusOptions}
          />
        </div>
      </div>
    );
  } else if (component === "superCodes") {
    const promotionTypeOptions = [
      {
        label: "Permanent",
        value: "permanent",
      },
      {
        label: "One Time",
        value: "one time",
      },
    ];
    return (
      <div
        className={styles.filter_div}
        style={{
          gap: "25px",
        }}
      >
        <div
          className={styles.left}
          style={{
            width: "130%",
          }}
        >
          <div
            className={styles.input}
            style={{
              width: "100%",
            }}
          >
            <div onClick={() => null} className={styles.search_logo}></div>
            <input
              placeholder="Search"
              className={styles.input_input}
              onChange={(e) => globalSearch(e.target.value)}
            ></input>
          </div>
        </div>
        <div className={styles.rightPart}>
          <Select
            allowClear={true}
            onChange={(e) => {
              setCreatedByFilter(e);
            }}
            placeholder="Created By"
            style={{
              width: "150px",
              height: "46px",
            }}
            loading={loadingAdminNames}
            options={createdByOptions}
          />
          <Select
            allowClear={true}
            onChange={(e) => {
              setPromotionTypeFilter(e);
            }}
            placeholder="Promotion Type"
            style={{
              width: "150px",
              height: "46px",
            }}
            loading={loadingAdminNames}
            options={promotionTypeOptions}
          />
        </div>
      </div>
    );
  } else if (component === 2) {
    return (
      <div className={styles.filter_div}>
        <div className={styles.left}>
          <div className={styles.input}>
            <div onClick={() => null} className={styles.search_logo}></div>
            <input
              placeholder="Search"
              className={styles.input_input}
              onChange={(e) => globalSearch(e.target.value)}
            ></input>
          </div>
        </div>
      </div>
    );
  } else
    return (
      <div className={styles.filter_div}>
        <div className={styles.left}>
          <div className={styles.input}>
            <div onClick={() => null} className={styles.search_logo}></div>
            <input
              placeholder="Search"
              className={styles.input_input}
              onChange={(e) => globalSearch(e.target.value)}
            ></input>
          </div>
        </div>
        <div onClick={() => downloadPartnersCSV()} className={styles.right}>
          <div className={styles.add_new_asset}>Export To CSV</div>
        </div>
      </div>
    );
}

export default TableFilter;
